import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'
import { READINESS_QUERY_PREFIX } from './useDemands'

export interface ReadinessItem {
  field: string
  label: string
  message: string
  stage: string
  met: boolean
}

export interface DemandReadiness {
  stage: string
  next_stage: string | null
  items: ReadinessItem[]
}

/**
 * The checklist between moves (#1207): what the expectations engine would
 * warn about at the demand's next stage move, met and unmet, with the same
 * messages the 409 carries. Fetch only for viewers who can edit — the items
 * name triage internals, and the endpoint 403s everyone else.
 */
export function useDemandReadiness(demandId: number | undefined, enabled: boolean) {
  return useQuery<DemandReadiness>({
    // Prefix imported, not typed out: the invalidation list in useDemands is
    // the only place that knows this cache exists, and a literal here could
    // drift away from it without anything failing.
    queryKey: [READINESS_QUERY_PREFIX, demandId],
    queryFn: async () => {
      const res = await api.get<DemandReadiness>(`/demands/${demandId}/readiness`)
      return res.data
    },
    enabled: !!demandId && enabled,
    staleTime: 30 * 1000,
  })
}
